export const DRUG = "5a06b99b-73f5-461a-8f81-c8ae31bb5c32";
export const STD = "be9887d5-a989-4bb7-ba90-ac3e57287771";
export const PSYC_MHLT = "5d26834e-daf7-4d0f-a0ab-8aace6afef50";
export const HIV = "c0f322c2-d3c4-43af-8677-42ed3b210ca5";
export const HPV = "8888c3c9-6cc6-408b-bc5a-19d0b1a7cd0d";
export const PATIENT = "5b06b99b-73f5-461a-8f81-c8ae31bb5c32";
export const RELEASE = "5c06b99b-73f5-461a-8f81-c8ae31bb5c32";

export const CORRECT_FEEDBACK = "9a37fe6f-bbe7-43f3-8b80-750fae70e080";

export type EntityTypeId = typeof DRUG |
        typeof STD |
        typeof PSYC_MHLT |
        typeof HIV |
        typeof HPV |
        typeof PATIENT |
        typeof RELEASE;

export interface EntityType {
    readonly id: EntityTypeId;
    readonly name: string;
    readonly color: string;
}

export interface DetectedEntity {
    readonly id: string;
    readonly type: EntityTypeId;
    /**
     * Page number zero-indexed.
     */
    readonly page: number;
    readonly leftSide: number;
    readonly rightSide: number;
    readonly topSide: number;
    readonly bottomSide: number;
    readonly spanText: string;
    readonly confidence: number;
    readonly feedback?: string;
    readonly feedbackAccepted: boolean;
}

export interface ReviewEntity {
    readonly id: string;
    readonly type: EntityTypeId;
    /**
     * Page number zero-indexed.
     */
    readonly page: number;
    readonly leftSide: number;
    readonly rightSide: number;
    readonly topSide: number;
    readonly bottomSide: number;
    readonly spanText: string;
    readonly userId: number;
    readonly firstName: string;
    readonly lastName: string;
    readonly submitted: Date;
}

export interface PatientNames {
    readonly [key: string]: readonly DetectedEntity[];
}

export interface PatientNameMissingPages {
    readonly [key: number]: readonly DetectedEntity[];
}

export interface FeedbackType {
    readonly id: string;
    readonly entityTypes: readonly EntityTypeId[];
    readonly name: string;
    readonly description: string;
}

export interface AssessmentResult {
    readonly processId: string,
    readonly status: string,
    readonly detectedEntities: readonly DetectedEntity[];
    readonly patientNames: PatientNames;
    readonly reviewEntities: readonly ReviewEntity[]
    readonly confidence: number;
    readonly patientNameMissingPages: PatientNameMissingPages;
}